const DOCUMENT = 'PAYMENT_HISTORY_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  SEND_REQUEST: DOCUMENT + 'SEND_REQUEST',

  loadData: data => ({
    type: actions.LOAD,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  sendRequest: data => ({
    type: actions.SEND_REQUEST,
    payload: data,
  }),
};

export default actions;
